export const validateRequired = (value, fieldName) => {
    return !value ? `${fieldName} is required.` : "";
};

export const validateEmail = (email) => {
    return email && !/^\S+@\S+\.\S+$/.test(email) ? "Enter a valid email address." : "";
};

export const validateUrl = (url, fieldName) => {
    return url && !/^https?:\/\//.test(url) ? `${fieldName} must be a valid URL.` : "";
};

export const validateVersion = (version) => {
    return version && !/^\d+\.\d+\.\d+$/.test(version) ? "Version must be in x.x.x format (e.g., 1.0.0)." : "";
};

export const validateInfoFields = (data) => {
    const errors = {};

    errors.title = validateRequired(data.title, "Title");
    errors.description = validateRequired(data.description, "Description");
    errors.contactName = validateRequired(data.contact?.name, "Contact name");
    errors.contactEmail = validateRequired(data.contact?.email, "Contact email") || validateEmail(data.contact?.email);

    errors.version = validateVersion(data.version);
    errors.termsOfService = validateUrl(data.termsOfService, "Terms of Service");
    errors.contactUrl = validateUrl(data.contact?.url, "Contact URL");
    errors.licenseUrl = validateUrl(data.license?.url, "License URL");

    Object.keys(errors).forEach((key) => {
        if (!errors[key]) delete errors[key];
    });

    return errors;
};
